import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import ContractsValidCollectionLoadParams from "./valid-collection/contracts-valid-collection-params";
import ContractsValidCollectionRequest from "../../api/raily/contracts/valid-collection/contracts-valid-collection.request";
import contractsValidCollectionParamsFactory from "./valid-collection/contracts-valid-collection-params.factory";
import contractsApiService from "../../api/raily/contracts/contracts-api.service";
import ContractsValidCollectionError from "./valid-collection/contracts-valid-collection-error";
import { DataLoadDefaultErrors } from "../../utils/data-load-error/data-load-error";
import ContractsCargoTaxiListParams from "./cargo-taxi/list/contracts-cargo-taxi-list-params";
import ContractsCargoTaxiList from "./cargo-taxi/list/contracts-cargo-taxi-list";
import ContractsCargoTaxiListRequest from "../../api/raily/contracts/cargo-taxi/list/contracts-cargo-taxi-list-request";
import contractsCargoTaxiListParamsFactory from "./cargo-taxi/list/contracts-cargo-taxi-list-params.factory";
import ContractsCargoTaxiListResponse from "../../api/raily/contracts/cargo-taxi/list/contracts-cargo-taxi-list.response";
import contractsCargoTaxiListFactory from "./cargo-taxi/list/contracts-cargo-taxi-list.factory";
import ContractsMileageCargoCompanyDetailsParams from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details-params";
import ContractsMileageCargoCompanyDetailsError from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details-error";
import ContractsMileageCargoCompanyDetails from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details";
import contractsMileageCargoCompanyDetailsParamsFactory from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details-params.factory";
import contractsMileageCargoCompanyDetailsFactory from "./mileage/cargo-company-details/contracts-mileage-cargo-company-details.factory";
import ContractsTaxiForwardingContractRequest from "../../api/raily/contracts/taxi-forwarding/contract/contracts-taxi-forwarding-contract.request";
import ContractsTaxiForwardingContractResponse from "../../api/raily/contracts/taxi-forwarding/contract/contracts-taxi-forwarding-contract.response";
import contractsValidCollectionFactory from "./valid-collection/contracts-valid-collection.factory";
import ContractsTaxiDriverAddError from "./taxi-driver/add/contracts-taxi-driver-add-error";
import ContractsTaxiDriverAdd from "./taxi-driver/add/contracts-taxi-driver-add";
import contractsTaxiDriverAddParamsFactory from "./taxi-driver/add/contracts-taxi-driver-add-params.factory";
import contractsTaxiDriverAddFactory from "./taxi-driver/add/contracts-taxi-driver-add.factory";
import ContractsTaxiForwardingContractParams from "./taxi-forwarding/contract/contracts-taxi-forwarding-contract-params";
import ContractsTaxiForwardingContract from "./taxi-forwarding/contract/contracts-taxi-forwarding-contract";
import contractsTaxiForwardingContractParamsFactory from "./taxi-forwarding/contract/contracts-taxi-forwarding-contract-params.factory";
import contractsTaxiForwardingContractFactory from "./taxi-forwarding/contract/contracts-taxi-forwarding-contract.factory";
import ContractsTaxiForwardingContractAddRequest from "../../api/raily/contracts/taxi-forwarding/add/contracts-taxi-forwarding-contract-add.request";
import ContractsTaxiForwardingContractDetailsRequest from "../../api/raily/contracts/taxi-forwarding/details/contracts-taxi-forwarding-contract-details.request";
import ContractsTaxiForwardingContractListRequest from "../../api/raily/contracts/taxi-forwarding/list/contracts-taxi-forwarding-contract-list.request";
import ContractsTaxiForwardingContractUpdateRequest from "../../api/raily/contracts/taxi-forwarding/update/contracts-taxi-forwarding-contract-update.request";
import ContractsTaxiForwardingContractAddError from "./taxi-forwarding/add/contracts-taxi-forwarding-contract-add-error";
import ContractsTaxiForwardingContractAddParams from "./taxi-forwarding/add/contracts-taxi-forwarding-contract-add-params";
import ContractsTaxiForwardingContractDetails from "./taxi-forwarding/details/contracts-taxi-forwarding-contract-details";
import ContractsTaxiForwardingContractDetailsError from "./taxi-forwarding/details/contracts-taxi-forwarding-contract-details-error";
import ContractsTaxiForwardingContractDetailsParams from "./taxi-forwarding/details/contracts-taxi-forwarding-contract-details-params";
import ContractsTaxiForwardingContractList from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list";
import ContractsTaxiForwardingContractListError from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list-error";
import ContractsTaxiForwardingContractListParams from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list-params";
import ContractsTaxiForwardingContractUpdateError from "./taxi-forwarding/update/contracts-taxi-forwarding-contract-update-error";
import ContractsTaxiForwardingContractUpdateParams from "./taxi-forwarding/update/contracts-taxi-forwarding-contract-update-params";
import contractsTaxiForwardingContractAddParamsFactory from "./taxi-forwarding/add/contracts-taxi-forwarding-contract-add-params.factory";
import contractsTaxiForwardingContractListParamsFactory from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list-params.factory";
import contractsTaxiForwardingContractListFactory from "./taxi-forwarding/list/contracts-taxi-forwarding-contract-list.factory";
import contractsTaxiForwardingContractUpdateParamsFactory from "./taxi-forwarding/update/contracts-taxi-forwarding-contract-update-params.factory";
import contractsTaxiForwardingContractDetailsFactory from "./taxi-forwarding/details/contracts-taxi-forwarding-contract-details.factory";
import ContractsTaxiDriverDetailsRequest from "../../api/raily/contracts/taxi-driver/details/contracts-taxi-driver-details.request";
import ContractsTaxiDriverUpdateRequest from "../../api/raily/contracts/taxi-driver/update/contracts-taxi-driver-update.request";
import ContractsTaxiDriverDetails from "./taxi-driver/details/contracts-taxi-driver-details";
import ContractsTaxiDriverDetailsError from "./taxi-driver/details/contracts-taxi-driver-details-error";
import ContractsTaxiDriverDetailsParams from "./taxi-driver/details/contracts-taxi-driver-details-params";
import contractsTaxiDriverDetailsFactory from "./taxi-driver/details/contracts-taxi-driver-details.factory";
import ContractsTaxiDriverUpdateError from "./taxi-driver/update/contracts-taxi-driver-update-error";
import ContractsTaxiDriverUpdateParams from "./taxi-driver/update/contracts-taxi-driver-update-params";
import contractsTaxiDriverUpdateParamsFactory from "./taxi-driver/update/contracts-taxi-driver-update-params.factory";
import contractsMileageDetailsParamsFactory from "./mileage/details/contracts-mileage-details-params.factory";
import ContractsMileageAddError from "./mileage/add/contracts-mileage-add-error";
import ContractsMileageAddParams from "./mileage/add/contracts-mileage-add-params";
import contractsMileageAddParamsFactory from "./mileage/add/contracts-mileage-add-params.factory";
import ContractsMileageDetails from "./mileage/details/contracts-mileage-details";
import ContractsMileageDetailsError from "./mileage/details/contracts-mileage-details-error";
import ContractsMileageDetailsParamsParams from "./mileage/details/contracts-mileage-details-params";
import contractsMileageDetailsFactory from "./mileage/details/contracts-mileage-details.factory";
import ContractsMileageList from "./mileage/list/contracts-mileage-list";
import ContractsMileageListError from "./mileage/list/contracts-mileage-list-error";
import ContractsMileageListParams from "./mileage/list/contracts-mileage-list-params";
import contractsMileageListParamsFactory from "./mileage/list/contracts-mileage-list-params.factory";
import contractsMileageListFactory from "./mileage/list/contracts-mileage-list.factory";
import ContractsMileageTemplate from "./mileage/template/contracts-mileage-template";
import contractsMileageTemplateFactory from "./mileage/template/contracts-mileage-template.factory";
import ContractsMileageUpdateError from "./mileage/update/contracts-mileage-update-error";
import ContractsMileageUpdateParams from "./mileage/update/contracts-mileage-update-params";
import contractsMileageUpdateParamsFactory from "./mileage/update/contracts-mileage-update-params.factory";
import ContractsCargoTaxiAddRequest from "../../api/raily/contracts/cargo-taxi/add/contracts-cargo-taxi-add.request";
import ContractsCargoTaxiDetailsRequest from "../../api/raily/contracts/cargo-taxi/details/contracts-cargo-taxi-details.request";
import ContractCargoTaxiUpdateRequest from "../../api/raily/contracts/cargo-taxi/update/contracts-cargo-taxi-update.request";
import ContractsCargoTaxiAddError from "./cargo-taxi/add/contracts-cargo-taxi-add-error";
import ContractsCargoTaxiAddParams from "./cargo-taxi/add/contracts-cargo-taxi-add-params";
import contractsCargoTaxiAddParamsFactory from "./cargo-taxi/add/contracts-cargo-taxi-add-params.factory";
import ContractsCargoTaxiDetails from "./cargo-taxi/details/contracts-cargo-taxi-details";
import ContractsCargoTaxiDetailsError from "./cargo-taxi/details/contracts-cargo-taxi-details-error";
import ContractsCargoTaxiDetailsParams from "./cargo-taxi/details/contracts-cargo-taxi-details-params";
import contractsCargoTaxiDetailsParamsFactory from "./cargo-taxi/details/contracts-cargo-taxi-details-params.factory";
import contractsCargoTaxiDetailsFactory from "./cargo-taxi/details/contracts-cargo-taxi-details.factory";
import ContractsCargoTaxiUpdateError from "./cargo-taxi/update/contracts-cargo-taxi-update-error";
import ContractsCargoTaxiUpdateParams from "./cargo-taxi/update/contracts-cargo-taxi-update-params";
import contractsCargoTaxiUpdateRequestFactory from "./cargo-taxi/update/contracts-cargo-taxi-update-params.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import ContractsTaxiDriverAddParams from "./taxi-driver/add/contracts-taxi-driver-add-params";

const getValidCollection = async (
  params: ContractsValidCollectionLoadParams,
  abortSignal: AbortSignal,
): Promise<any> => {
  const request: ContractsValidCollectionRequest =
    contractsValidCollectionParamsFactory.create(params);

  try {
    const response = await contractsApiService().getValidCollection(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsValidCollectionFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | ContractsValidCollectionError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoTaxiContractList = async (
  params: ContractsCargoTaxiListParams,
  abortSignal: AbortSignal,
): Promise<ContractsCargoTaxiList> => {
  const request: ContractsCargoTaxiListRequest =
    contractsCargoTaxiListParamsFactory.create(params);

  try {
    const response: ContractsCargoTaxiListResponse =
      await contractsApiService().getCargoTaxiContractList(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const cargoTaxiContractList: ContractsCargoTaxiList =
      contractsCargoTaxiListFactory.create(response);

    return cargoTaxiContractList;
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const addCargoTaxiContract = async (
  params: ContractsCargoTaxiAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: ContractsCargoTaxiAddRequest =
    contractsCargoTaxiAddParamsFactory.create(params);

  try {
    const response = await contractsApiService().addCargoTaxiContract(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | ContractsCargoTaxiAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateCargoTaxiContract = async (
  params: ContractsCargoTaxiUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: ContractCargoTaxiUpdateRequest =
    contractsCargoTaxiUpdateRequestFactory.create(params);

  try {
    const response = await contractsApiService().updateCargoTaxiContract(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | ContractsCargoTaxiUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getCargoTaxiContractDetails = async (
  params: ContractsCargoTaxiDetailsParams,
  abortSignal: AbortSignal,
): Promise<ContractsCargoTaxiDetails> => {
  const request: ContractsCargoTaxiDetailsRequest =
    contractsCargoTaxiDetailsParamsFactory.create(params);

  try {
    const response = await contractsApiService().getCargoTaxiContractDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsCargoTaxiDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | ContractsCargoTaxiDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getContractMileageCargoCompanyDetails = async (
  loadParams: ContractsMileageCargoCompanyDetailsParams,
  abortSignal: AbortSignal,
): Promise<ContractsMileageCargoCompanyDetails> => {
  const request =
    contractsMileageCargoCompanyDetailsParamsFactory.create(loadParams);

  try {
    const response =
      await contractsApiService().getContractMileageCargoCompanyDetails(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsMileageCargoCompanyDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | ContractsMileageCargoCompanyDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiForwardingContract = async (
  params: ContractsTaxiForwardingContractParams,
  abortSignal: AbortSignal,
): Promise<ContractsTaxiForwardingContract> => {
  const request: ContractsTaxiForwardingContractRequest =
    contractsTaxiForwardingContractParamsFactory.create(params);

  try {
    const response: ContractsTaxiForwardingContractResponse =
      await contractsApiService().getTaxiForwardingContract(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const contractsTaxiForwarding: ContractsTaxiForwardingContract =
      contractsTaxiForwardingContractFactory.create(response);

    return contractsTaxiForwarding;
  } catch (_error) {
    const error = _error as HttpError;

    throw handleErrorFactory.handleError(error);
  }
};

const addTaxiDriverContract = async (
  loadParams: ContractsTaxiDriverAddParams,
  abortSignal: AbortSignal,
): Promise<ContractsTaxiDriverAdd> => {
  const request = contractsTaxiDriverAddParamsFactory.create(loadParams);

  try {
    const response = await contractsApiService().addTaxiDriverContract(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsTaxiDriverAddFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | ContractsTaxiDriverAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addTaxiForwardingContract = async (
  params: ContractsTaxiForwardingContractAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: ContractsTaxiForwardingContractAddRequest =
    contractsTaxiForwardingContractAddParamsFactory.create(params);

  try {
    const response = await contractsApiService().addTaxiForwardingContract(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | ContractsTaxiForwardingContractAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiForwardingContractList = async (
  params: ContractsTaxiForwardingContractListParams,
  abortSignal: AbortSignal,
): Promise<ContractsTaxiForwardingContractList> => {
  const request: ContractsTaxiForwardingContractListRequest =
    contractsTaxiForwardingContractListParamsFactory.create(params);

  try {
    const response = await contractsApiService().getTaxiForwardingContractList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsTaxiForwardingContractListFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | ContractsTaxiForwardingContractListError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateTaxiForwardingContract = async (
  params: ContractsTaxiForwardingContractUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: ContractsTaxiForwardingContractUpdateRequest =
    contractsTaxiForwardingContractUpdateParamsFactory.create(params);

  try {
    const response = await contractsApiService().updateTaxiForwardingContract(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as
      | HttpError
      | ContractsTaxiForwardingContractUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiForwardingContractDetails = async (
  params: ContractsTaxiForwardingContractDetailsParams,
  abortSignal: AbortSignal,
): Promise<ContractsTaxiForwardingContractDetails> => {
  const request: ContractsTaxiForwardingContractDetailsRequest = {
    contractUuid: params.contractUuid,
  };

  try {
    const response =
      await contractsApiService().getTaxiForwardingContractDetails(
        request,
        abortSignal,
      );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsTaxiForwardingContractDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as
      | HttpError
      | ContractsTaxiForwardingContractDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateTaxiDriverContract = async (
  params: ContractsTaxiDriverUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: ContractsTaxiDriverUpdateRequest =
    contractsTaxiDriverUpdateParamsFactory.create(params);

  try {
    const response = await contractsApiService().updateTaxiDriverContract(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | ContractsTaxiDriverUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getTaxiDriverContractDetails = async (
  params: ContractsTaxiDriverDetailsParams,
  abortSignal: AbortSignal,
): Promise<ContractsTaxiDriverDetails> => {
  const request: ContractsTaxiDriverDetailsRequest = {
    contractId: params.contractUuid,
  };

  try {
    const response = await contractsApiService().getTaxiDriverContractDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiDriverContractDetails =
      contractsTaxiDriverDetailsFactory.create(response);

    return taxiDriverContractDetails;
  } catch (_error) {
    const error = _error as HttpError | ContractsTaxiDriverDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getMileageContractList = async (
  params: ContractsMileageListParams,
  abortSignal: AbortSignal,
): Promise<ContractsMileageList> => {
  const request = contractsMileageListParamsFactory.create(params);

  try {
    const response = await contractsApiService().getMileageContractList(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const data = contractsMileageListFactory.create(response);
    return data;
  } catch (_error) {
    const error = _error as ContractsMileageListError | HttpError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const addMileageContract = async (
  params: ContractsMileageAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = contractsMileageAddParamsFactory.create(params);

  try {
    const response = await contractsApiService().addMileageContract(
      request,
      abortSignal,
    );

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as ContractsMileageAddError | HttpError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const updateMileageContract = async (
  params: ContractsMileageUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = contractsMileageUpdateParamsFactory.create(params);

  try {
    const response = await contractsApiService().updateMileageContract(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as ContractsMileageUpdateError | HttpError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getMileageContractTemplate = async (
  abortSignal: AbortSignal,
): Promise<ContractsMileageTemplate> => {
  try {
    const response =
      await contractsApiService().getMileageContractTemplate(abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsMileageTemplateFactory.create(response);
  } catch (_error) {
    const error = _error as DataLoadDefaultErrors | HttpError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getMileageContractDetails = async (
  params: ContractsMileageDetailsParamsParams,
  abortSignal: AbortSignal,
): Promise<ContractsMileageDetails> => {
  const request = contractsMileageDetailsParamsFactory.create(params);

  try {
    const response = await contractsApiService().getMileageContractDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return contractsMileageDetailsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | ContractsMileageDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const contractsService = {
  getValidCollection,
  getCargoTaxiContractList,
  addCargoTaxiContract,
  updateCargoTaxiContract,
  getCargoTaxiContractDetails,
  getContractMileageCargoCompanyDetails,
  getTaxiForwardingContract,
  addTaxiDriverContract,
  addTaxiForwardingContract,
  getTaxiForwardingContractList,
  updateTaxiForwardingContract,
  getTaxiForwardingContractDetails,
  updateTaxiDriverContract,
  getTaxiDriverContractDetails,
  getMileageContractList,
  addMileageContract,
  updateMileageContract,
  getMileageContractTemplate,
  getMileageContractDetails,
};

export default contractsService;
